import { StudentCourseForm, studentFromsApi } from "api/studentFromsApi";
import { useEffect, useState } from "react";

export const useStudentApplicationForm = (studentId: number, courseId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<StudentCourseForm>();

  const fetchResource = async () => {
    setLoading(true);
    try {
      const response = await studentFromsApi.fetchApplicationForm(studentId, courseId);
      setData(response.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResource();
  }, [studentId, courseId]);

  return { loading, data, refetch: fetchResource };
};
